import type React from "react";
import { styled } from "@mui/material/styles";

const Container = styled("div")({
	overflow: "hidden",
	display: "grid",
	gridTemplateRows: "64px 1fr",
});

interface SiteContentProps {
	readonly header: React.ReactNode;
	readonly children: React.ReactNode;
}

export const SiteContent: React.FC<SiteContentProps> = ({ header, children }) => {
	return (
		<Container>
			{header}
			{children}
		</Container>
	);
};
